import * as React from 'react'
import Head from 'next/head'
import { getI18n } from 'react-i18next'

import { LocaleEnum } from '@/types/locale'

// meta 태그는 _app head로 들어가서 페이지마다 다른 메타가 있을 경우 교체
// _document에 들어갈 경우 교체되지 않고 중복 작성되어 문제가 발생할 여지 있음
export default function HtmlHeadMetas() {
  const t = React.useCallback(
    (key: string) => getI18n().getResource(getI18n().language, 'header', key),
    [],
  )
  return (
    <Head>
      <title key="title">{t('title')}</title>
      <meta charSet="utf-8" />
      <link
        rel="alternate"
        hrefLang={LocaleEnum.en}
        href={`${process.env.NEXT_PUBLIC_THE_RICH_DOMAIN_URL}/en`}
      />
      <link
        rel="alternate"
        hrefLang={LocaleEnum.ko}
        href={process.env.NEXT_PUBLIC_THE_RICH_DOMAIN_URL}
      />
      <link rel="shortcut icon" href="/favicon.ico" />
      <meta name="title" content={t('title')} />
      <meta name="description" content={t('description')} />
      <meta
        name="viewport"
        content="width=device-width, height=device-height, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="apple-mobile-web-app-title" content="TheRich" />
      <meta name="theme-color" content="#121722" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="author" content="TheRich" />
      <meta name="image" content="https://images.therich.io/ogtag/home.png" />
      <link rel="manifest" href="/manifest.json" />
      <link rel="apple-touch-icon" href="/icon.png"></link>
    </Head>
  )
}
